var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rpanel-inner",class:{'rpanel-right':_vm.side=='right', 'rpanel-active':_vm.active }},[_vm._t("default",null,{"rpanel":_vm.self})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }